import React from "react";
import Seo from "../seo/Seo";
import { Section, Heading, PageHero, CTASection, Bullets } from "../components/ui-kit";
import { IMAGES } from "../mock/mock";

const breadcrumbs = [{ name: "Home", path: "/" }, { name: "Custom Home Design", path: "/custom-home-design" }];

const Design = () => (
  <>
    <Seo
      title="Custom Home Design in Central Florida | Build Highland Homes"
      description="Our custom home design process starts with your vision, lifestyle, and lot. Explore how Build Highland Homes designs personalized floor plans, layouts, and finishes."
      path="/custom-home-design"
      keywords="custom home design, custom home design and build, floor plan design, home design central florida"
      breadcrumbs={breadcrumbs}
    />
    <PageHero overline="Design & Build" title="Custom Home Design" subtitle="Great custom homes start with thoughtful design. We translate your vision, lifestyle, and lot into a floor plan and style that are unmistakably yours." image={IMAGES.blueprint} />

    <Section className="bg-[#0b0b0b]">
      <div className="grid lg:grid-cols-2 gap-12 items-center">
        <img src={IMAGES.realKitchen} alt="Custom kitchen design by Build Highland Homes" className="w-full h-[440px] object-cover border border-[#c9a24b]/20" loading="lazy" />
        <div>
          <Heading center={false} overline="Designed Around You" title="Design That Fits Your Life & Your Lot" subtitle="We design each home around how you live and the property you're building on — not a fixed production catalog." />
          <Bullets items={[
            "Homeowner vision and lifestyle first",
            "Floor-plan development and room layouts",
            "Kitchens, primary suites, home offices & outdoor living",
            "Garages, storage, and multigenerational options",
            "Windows, doors, energy efficiency & finishes",
          ]} />
        </div>
      </div>
    </Section>

    <Section className="bg-[#0f0f0f]">
      <Heading overline="Design Considerations" title="What We Design Around" />
      <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-5">
        {["Architectural Style","One vs Two Story","Open-Concept Living","Chef's Kitchens","Primary Suites","Home Offices","Outdoor Living","Storage & Garages"].map((t) => (
          <div key={t} className="bg-[#141414] border border-[#c9a24b]/15 p-5 text-center">
            <span className="font-serif-display text-lg text-[#e3c77a]">{t}</span>
          </div>
        ))}
      </div>
    </Section>

    <CTASection title="Let's Design Your Custom Home" />
  </>
);

export default Design;
